import { render } from "./Review.vue?vue&type=template&id=24352a66&scoped=true&bindings={\"isGdprVisible\":\"data\",\"isApproved\":\"data\",\"isLoading\":\"data\",\"currentView\":\"data\",\"createUserAccount\":\"data\",\"onEdit\":\"options\",\"openGdpr\":\"options\",\"closeGdpr\":\"options\",\"onSubmit\":\"options\",\"getPhoneType\":\"options\",\"hasOnlineMembership\":\"options\",\"stepName\":\"options\",\"info\":\"options\"}"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import "./Review.vue?vue&type=style&index=0&id=24352a66&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24352a66"

export default script